<div class="bg-white dark:bg-gray-900/50 rounded-md w-full">
    <div class="p-2 overflow-x-auto h-96">
        <div class="inline-block min-w-full shadow rounded-lg overflow-hidden">

            <table class="w-full text-center text-gray-900 dark:text-gray-300">

                <thead>
                    <tr class="border-b-2 border-gray-200 dark:border-gray-600 bg-gray-100 dark:bg-gray-900/50 text-gray-600 dark:text-gray-300">
                        <th class="px-2 py-3">No.</th>
                        <th class="px-2 py-3">Hora</th>
                        <th class="px-2 py-3">No. Evento</th>
                        <th class="px-2 py-3">Clase</th>
                        <th class="px-2 py-3">Falla Lectura Tag</th>
                        <th class="px-2 py-3">Recarga no reflejada</th>
                        <th class="px-2 py-3">No baja barrera</th>
                        <th class="px-2 py-3">Touch no responde</th>
                        <th class="px-2 py-3">Boton rojo encendido</th>
                        <th class="px-2 py-3">Touch escribe otros numeros</th>
                    </tr>
                </thead>
                <tbody>

                  <tr *ngFor="let falla of fallas; let i = index" class="border-b border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-900/50">

                    <td class="p-2">{{ i + 1 }}</td>

                    <td class="p-2">
                        {{ falla.fecha_hora | date:'dd/MM/yyyy HH:mm:ss' }}
                    </td>

                    <td class="p-2">
                        {{ falla.fallas.extraData }}
                    </td>

                    <td class="p-2">
                        {{ falla.tipo_vehiculo.tipo }}
                    </td>

                    <td class="p-2">{{ falla.id_subtipo_cruce == 80 ? 'X' : '' }}</td>
                    <td class="p-2">{{ falla.id_subtipo_cruce == 82 ? 'X' : '' }}</td>
                    <td class="p-2">{{ falla.id_subtipo_cruce == 41 ? 'X' : '' }}</td>
                    <td class="p-2">{{ falla.id_subtipo_cruce == 84 ? 'X' : '' }}</td>
                    <td class="p-2">{{ falla.id_subtipo_cruce == 83 ? 'X' : '' }}</td>
                    <td class="p-2">{{ falla.id_subtipo_cruce == 85 ? 'X' : '' }}</td>

                </tr>

                </tbody>
            </table>

        </div>
    </div>
</div>
